import { GatsbyBrowser } from 'gatsby'

import wrapWithProvider from './src/boot/wrap-with-provider'

export const wrapRootElement = wrapWithProvider

export const onServiceWorkerUpdateReady: GatsbyBrowser['onServiceWorkerUpdateReady'] = () =>
  window.location.reload(true)
